// extracted by mini-css-extract-plugin
export default {"blockwrapper":"KU","header":"LU","name":"MU","columns":"NU","imagewrapper":"OU","addinfo":"PU","description":"QU","price":"RU","old":"SU","new":"TU","desc_d":"UU","infoblock":"VU","desc_m":"WU"};
    if(module.hot) {
      // 1721922365796
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  